import axios from 'axios';

import { getAccessToken } from '../utils/portal-token.util';

const defaultHeaders = {
  'Access-Control-Allow-Origin': '*',
  Authorization: `Bearer ${getAccessToken()}`,
  'x-authorization-extra-info':
    process.env.REACT_APP_X_AUTHORIZATION_EXTRA_INFO,
  'Content-Type': 'application/json;charset=utf-8'
};

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { ...defaultHeaders }
});
